export class FederatedSyncState {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "FederatedSyncStatus",
            "format": ""
        },
        {
            "name": "lastSyncTime",
            "baseName": "lastSyncTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastAttemptTime",
            "baseName": "lastAttemptTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastError",
            "baseName": "lastError",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastSyncStats",
            "baseName": "lastSyncStats",
            "type": "FederatedSyncStats",
            "format": ""
        },
        {
            "name": "inaccessibleDataLocations",
            "baseName": "inaccessibleDataLocations",
            "type": "Array<InaccessibleDataLocation>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FederatedSyncState.attributeTypeMap;
    }
    constructor() {
    }
}
